export default data => {
  let splash = document.getElementById('splash');
  let bg = document.getElementById('splashBg')
  if (data.next.namespace == 'home') {
    setTimeout(() => {
      bg.classList.add('opacity-0')
      setTimeout(() => {
        bg.classList.add('hidden')
      }, 2200)
    }, 900) //was 3200
    // The 3200 time above is the delay time of the black background i.e. how long before the black fades out. The 5200 below is how long before the logo fades, at 4200 it is 1 seconds longer than the background.
    setTimeout(() => {
      splash.classList.add('opacity-0');
      setTimeout(() => {
        splash.classList.add('hidden');
      }, 1200);
    }, 1200); // was 5200
  } else {
    splash.classList.add('hidden');
  }
};
